"use strict";
import storage from './storage';

/**
 *
 * sitesSessionStorageService
 *
 * @namespace sitesSessionStorageService
 * @ignore
 */

const STORAGE_METADATA = storage.metadata.SITES_SS;
let publicMethods = {};
publicMethods.initStorage = function(){
    if (!storage(STORAGE_METADATA)) {
        storage(STORAGE_METADATA, {});
        return true;
    }
    return false;
};

publicMethods.getItem = function(key){
    publicMethods.initStorage();
    let storageVal = storage(STORAGE_METADATA);
    return storageVal && storageVal.hasOwnProperty(key) ? storageVal[key] : false;
};

publicMethods.writeItem = function(key, data){
    publicMethods.initStorage();
    let storageVal = storage(STORAGE_METADATA);
    if (storageVal && data) {
        storageVal[key] = data;
        storage(STORAGE_METADATA, storageVal);
        return storageVal[key];
    }
    return false;
};

publicMethods.removeItem = function(key){
    let storageVal = storage(STORAGE_METADATA);
    if (storageVal && storageVal[key]) {
        delete storageVal[key];
        storage(STORAGE_METADATA, storageVal);
        return true;
    }
    return false;
};

publicMethods.removeAll = function(){
    storage.removeItem(STORAGE_METADATA);
    return true;
};
export default publicMethods;
